/**
 * Logo de la marca — WHITE-LABEL: para vender con otro nombre,
 * reemplaza este SVG por el logo del comprador.
 * Usa tspan con colores directos (sin url() gradients) para 100% compatibilidad cross-browser
 */
export default function GcrLogo({ size = 50 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 70"
      width={size * (320 / 70)}
      height={size}
      style={{ flexShrink: 0, display: "block" }}
    >
      <defs>
        <linearGradient id="gcr_shield_g" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F0C96A" />
          <stop offset="50%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#A07C20" />
        </linearGradient>
        <linearGradient id="gcr_bars_g" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#A07C20" />
          <stop offset="100%" stopColor="#F0C96A" />
        </linearGradient>
      </defs>

      {/* Shield icon */}
      <g transform="translate(4, 2)">
        <path
          d="M32 0 L62 10 L62 40 C62 58 44 68 32 72 C20 68 2 58 2 40 L2 10 Z"
          fill="rgba(212,175,55,0.07)"
          stroke="url(#gcr_shield_g)"
          strokeWidth="1.8"
        />
        {/* Bar chart — ganancias crecientes */}
        <rect x="12" y="38" width="8" height="14" rx="1.5" fill="url(#gcr_bars_g)" opacity="0.9" />
        <rect x="23" y="30" width="8" height="22" rx="1.5" fill="url(#gcr_bars_g)" opacity="0.9" />
        <rect x="34" y="20" width="8" height="32" rx="1.5" fill="url(#gcr_bars_g)" opacity="0.9" />
        {/* Flecha hacia arriba */}
        <path d="M46 36 L50 26 L54 36" stroke="#F0C96A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <line x1="50" y1="26" x2="50" y2="52" stroke="#F0C96A" strokeWidth="2.2" strokeLinecap="round" />
        {/* Estrella / destello */}
        <path
          d="M50 20 L51.5 24.5 L56 24.5 L52.5 27.2 L54 31.5 L50 29 L46 31.5 L47.5 27.2 L44 24.5 L48.5 24.5 Z"
          fill="#F7E08A"
          opacity="0.95"
        />
      </g>

      {/* "GANA CON" — plata elegante */}
      <text
        x="82"
        y="27"
        fontFamily="'Outfit', system-ui, sans-serif"
        fontWeight="400"
        fontSize="13"
        fill="#C8C8C8"
        letterSpacing="6"
      >
        GANA CON
      </text>

      {/* "RONALD" — tspan con colores directos (sin url gradients) → siempre dorado */}
      <text
        x="80"
        y="63"
        fontFamily="'Outfit', system-ui, sans-serif"
        fontWeight="800"
        fontSize="42"
        letterSpacing="1"
      >
        <tspan fill="#F7E08A">R</tspan>
        <tspan fill="#F0C060">O</tspan>
        <tspan fill="#D4AF37">N</tspan>
        <tspan fill="#D4AF37">A</tspan>
        <tspan fill="#C4A030">L</tspan>
        <tspan fill="#A07C20">D</tspan>
      </text>
    </svg>
  );
}
